export const METRICS = [
  {
    value: "20+",
    label: "Years",
    detail: "Working across people, leadership, business and experience",
  },
  {
    value: "$30M+",
    label: "Revenue generated",
    detail: "Through email and customer engagement initiatives",
  },
  {
    value: "5X",
    label: "Increase",
    detail: "In customer lifetime value",
  },
  {
    value: "213%",
    label: "Increase",
    detail: "In customer-service ticket conversion",
  },
  {
    value: "115K+",
    label: "Interactions",
    detail: "Customer interactions managed and transformed",
  },
];

export const TESTIMONIALS = [
  {
    featured: true,
    quote:
      "Jocelyn was an incredible mentor and leader during my time at Sash. Under her guidance, I learned to navigate challenges, develop my skills, and grow into my role with confidence. She doesn't just manage people—she invests in them. Her coaching has set me up for long-term success, both personally and professionally. On top of that, her improvements to our systems and workflows made our team more efficient and empowered us to deliver a better experience for our customers.",
    author: "Cheri T.",
    role: "Customer Experience Manager",
  },
  {
    quote:
      "Jocelyn has an incredible knack for wrangling chaos into clear action—translating big, messy ideas into plans that get results. Everything she touches is aligned with the bigger vision, and she makes sure no detail is lost in the process. From implementing systems that increased both efficiency and revenue, to launching high-impact projects that deepened customer loyalty, Jocelyn's impact has been nothing short of extraordinary. But beyond the strategy and execution, what stands out most is her ability to lead and lift others. Jocelyn has a way of mentoring, empowering, and inspiring a team that changes how people show up. Our entire culture improved through her involvement. I will always welcome the opportunity to work with her again—and any business would be lucky to have her.",
    author: "Nichole M.",
    role: "Founder and CEO",
  },
  {
    quote:
      "I met Jocelyn during a time of explosive growth for my personal brand. As thrilling as it is, it can be disorienting and difficult to set priorities and boundaries at times. Jocelyn has this incredible ability to cut through the noise and help me get clear on what I truly need. Whenever I feel overwhelmed by the demands of my business, a conversation with Jocelyn brings me back to center, leaving me focused, energized, and more able to enjoy the success I've worked so hard for. Plus, taking her guidance on scalable processes for operational functions is a game-changer! Her insights and unconditional support have been invaluable.",
    author: "Michelle K.",
    role: "Social Media Influencer and Content Creator",
  },
  {
    quote:
      "Working with Jocelyn was truly transformative. When I started, I felt completely stuck—my business, personal life, and health goals were all tangled together, leaving me overwhelmed and unsure of where to begin. She has this rare ability to be both incredibly warm and deeply insightful, creating a space that feels safe, supportive, and motivating all at once. Through her thoughtful guidance, clear exercises, and consistent weekly coaching, Jocelyn helped me untangle the chaos and see things with clarity again. What once felt like a blur became structured and manageable. She introduced practical tools that allowed me to compartmentalize each area of my life in a way that finally made sense, giving me the ability to focus, take action, and build real momentum. What stood out most was how approachable and genuinely invested she is—Jocelyn meets you exactly where you are, without judgment, and helps you move forward with confidence. I now have not only a clearer vision for my future, but also the systems and mindset to keep progressing toward it. I'm incredibly grateful for her guidance and would wholeheartedly recommend Jocelyn to anyone feeling stuck or seeking meaningful change.",
    author: "Wendy C.",
    role: "Coaching Client",
  },
  {
    quote:
      "Working with Jocelyn was a truly transformative experience. She facilitated a highly personalized coaching program that empowered me to achieve significant personal growth and professional development while increasing my overall self-awareness. During our one-on-one coaching sessions, Jocelyn created a compassionate and supportive environment, guiding me to discover my authentic self and nurture more fulfilling, connected relationships. Throughout our time together, Jocelyn helped me shift long-held perspectives, break free from limiting beliefs, and realign with my core values. The changes I made during our journey together have been lasting and deeply meaningful, both personally and professionally.",
    author: "Jill S.",
    role: "Coaching Client",
  },
];

export const CAREER_THREAD = [
  { step: "01", name: "Sales", desc: "Sales taught me how people make decisions." },
  { step: "02", name: "Marketing", desc: "Marketing taught me how people connect with ideas." },
  {
    step: "03",
    name: "Customer Experience",
    desc: "Customer experience taught me why people stay, leave, complain, forgive, advocate, and come back.",
  },
  {
    step: "04",
    name: "Operations",
    desc: "Operations taught me how systems either support people or make their lives unnecessarily hard.",
  },
  {
    step: "05",
    name: "Leadership",
    desc: "Leadership taught me that the same person can struggle or thrive depending on how they're seen, supported, challenged, and led.",
  },
  {
    step: "06",
    name: "Coaching",
    desc: "Coaching gave me an entirely new language for understanding how human beings become who they are — and how they can choose something different.",
  },
];
